import { render, staticRenderFns } from "./AreaInteresse.vue?vue&type=template&id=1e43310e"
import script from "./AreaInteresse.vue?vue&type=script&lang=js"
export * from "./AreaInteresse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports